const CollateralPledgeRemove = () => {
  return (
    <div className="collateral-pledge-remove">
      <h1>Placeholder for Collateral Pledge Remove</h1>
    </div>
  );
};

export default CollateralPledgeRemove;
